module.exports = __webpack_public_path__ + "images/sale_sticker@1x.png?c82b62a1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sale_sticker@1x.png
// module id = 692
// module chunks = 7